import { safeDefine } from "../../registration/safe-define.js";
import { PlayButtonElement } from "../../ui/play-button/element.js";
//#region src/define/ui/play-button.ts
safeDefine(PlayButtonElement);
//#endregion
